module.exports = __webpack_public_path__ + "static/img/brees-2018-img-in-copy.b71c5ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2018-img-in-copy.jpg
// module id = fZc5
// module chunks = 1